import moment from 'utils/date/moment';

export default (timestamp: number) => {
	const nowTimestamp = moment().valueOf();
	return moment(nowTimestamp + timestamp);
};
